import React from 'react';

interface Props {
  style: React.CSSProperties;
}

export const CustomDivider: React.FC<Props> = ({ style }) => {
  return <div style={style}></div>;
};